import { Component, OnInit } from '@angular/core';
import { ClaimKey } from '../../../../../models/api/core/claim-key';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { AbsenceSummaryResponse } from '../../../../../models/api/view/claim/details/detail/absence/absence-summary-response';
import { StatusHistory } from '../../../../../models/api/view/claim/details/detail/absence/status-history';
import { RelatedClaim } from '../../../../../models/api/view/related-claims/related-claims-response';
import { BaseComponent } from '../../../../base/base.component';
import { PageHeaderComponent } from '../../../../core/labels/page-header.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { TogglePanelComponent } from '../../../../core/panels/toggle-panel.component';
import { RelatedClaimsComponent } from '../../../related-claims/related-claims.component';
import { AbsenceInformationComponent } from './absence-information.component';
import { AbsenceStatusHistoryComponent } from './absence-status-history.component';
import { leaveLink } from '../../../../../functions/claim/leaveLink';

@Component({
  selector: 'app-absence',
  imports: [
    PageHeaderComponent,
    AbsenceInformationComponent,
    TogglePanelComponent,
    CardComponent,
    RelatedClaimsComponent,
    AbsenceStatusHistoryComponent,
  ],
  template: ` <app-page-header label="Absence" />
    <app-absence-information [dataSource]="absences1" />
    <div class="tw-pb-4"></div>
    <app-toggle-panel>
      <div class="tw-flex tw-gap-4 tw-pb-4">
        @if (this.showRelatedClaims) {
          <app-card
            label="Related claims"
            [expanded]="false"
            [showExpand]="true"
            class="tw-grow"
          >
            <app-related-claims [dataSource]="relatedClaims" />
          </app-card>
        }
      </div>
      @if (this.claimStatusAuth) {
        <div class="tw-flex tw-gap-4 tw-pb-4">
          <app-card
            label="Status History"
            [expanded]="false"
            [showExpand]="true"
            class="tw-grow"
          >
            <app-absence-status-history [dataSource]="statusHistory" />
          </app-card>
        </div>
      }
    </app-toggle-panel>`,
  styles: ``,
})
export class AbsenceComponent extends BaseComponent implements OnInit {
  absences1: AbsenceSummaryResponse[] = [];
  relatedClaims: RelatedClaim[] = [];
  statusHistory: StatusHistory[] = [];
  currentClaim: ClaimRow;
  detailAuth = false;
  isLeaveLink = false;
  showRelatedClaims = false;
  claimStatusAuth = false;
  async ngOnInit(): Promise<void> {
    this.view.showLoading();
    this.currentClaim = this.view.currentClaim();
    this.detailAuth = this.session.authorize('Details');
    const recordSource = this.currentClaim.recordSource;
    this.isLeaveLink = leaveLink(recordSource);
    this.showRelatedClaims = this.detailAuth && !this.isLeaveLink;
    this.claimStatusAuth =
      leaveLink(recordSource) ||
      recordSource === 'T' ||
      this.view.authorize('LeaveStatusHistory');

    const claimKey: ClaimKey = {
      recordId: this.currentClaim.recordId,
      recordSource: this.currentClaim.recordSource,
    };

    // Execute API calls independently - each can succeed or fail separately
    const loadAbsences = this.api.absence
      .get(claimKey)
      .catch((): AbsenceSummaryResponse[] => []);
    const loadRelatedClaims = this.api.relatedClaims
      .get(claimKey)
      .catch((): RelatedClaim[] => []);
    const loadStatusHistory = this.api.statusHistory
      .get(claimKey)
      .catch((): StatusHistory[] => []);
    const [absences, relatedClaims, statusHistory] = await Promise.all([
      loadAbsences,
      loadRelatedClaims,
      this.claimStatusAuth
        ? loadStatusHistory
        : Promise.resolve([]),
    ]);

    this.absences1 = absences;
    this.relatedClaims = relatedClaims;
    this.statusHistory = statusHistory;
    this.view.hideLoading();
  }
}
